const messages = {
  title: "Boonuse kordaja",
  bandBonusTitle: "Boonus rehvi kohta kordajaga",
  amountLabel: "Min. rehvide arv (*)",
  label: "Boonuse kordaja",
  desc: "Bridgestone’i ja Firestone’i rehvide arv. Firestone’i rehvidele ei ole euroboonust.",
  goals: {
    loyal: "Lojaalne",
    bronze: "Pronks",
    silver: "Hõbe",
    gold: "Kuld",
    platinum: "Plaatina",
  },
  andMore: "ja rohkem",
  chooseTarget: "Vali",
  selectTarget: "Vali siit oma {year}. aasta eesmärk:",
  multiplication: "Boonus korrutatakse <b>{factor}</b>-ga",
  minTyres: "<b>Miinimum:</b> {tyre} rehvi",
};

export default {
  messages,
};
